import React, { useState } from 'react';

import Layout from 'ds/Layout';
import { Message } from 'shared';

import MessageElement from './Message';
import MessageThreadInput from './MessageThreadInput';
import { CreatableMessage } from './types';

interface Props {
  messages: Message[];
  onSubmit: (message: CreatableMessage) => Promise<void>;
  taskId?: number;
  messageDownloadPathPrefix?: string;
}

const MessageThread: React.FC<Props> = ({ messages, onSubmit, taskId, messageDownloadPathPrefix }) => {
  const [showAbsoluteTime, setShowAbsoluteTime] = useState<boolean>(true);

  return (
    <Layout>
      {messages.map((message, index) => (
        <Layout key={message.id} marginTop={index > 0 ? 24 : 0}>
          <MessageElement
            message={message}
            showAbsoluteTime={showAbsoluteTime}
            onToggleTimeFormat={() => setShowAbsoluteTime(!showAbsoluteTime)}
            taskId={taskId}
            messageDownloadPathPrefix={messageDownloadPathPrefix}
          />
        </Layout>
      ))}
      <Layout marginTop={8}>
        <MessageThreadInput onSubmit={onSubmit} />
      </Layout>
    </Layout>
  );
};

export default MessageThread;
